import { render, staticRenderFns } from "./Describe.vue?vue&type=template&id=37983056&scoped=true"
import script from "./Describe.vue?vue&type=script&lang=js"
export * from "./Describe.vue?vue&type=script&lang=js"
import style0 from "./Describe.vue?vue&type=style&index=0&id=37983056&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37983056",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37983056')) {
      api.createRecord('37983056', component.options)
    } else {
      api.reload('37983056', component.options)
    }
    module.hot.accept("./Describe.vue?vue&type=template&id=37983056&scoped=true", function () {
      api.rerender('37983056', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/Describe.vue"
export default component.exports